import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';

import { SoccerClub } from '../../../../models/soccerClub';
import { getClub } from '../../../../store/selectors/club.selectors';
import { AppState } from '../../../../store/states/app.state';
import { Budget } from 'src/app/data-editor/models/models';
import { BudgetService } from 'src/app/data-editor/services/budget.service';

@Component({
  selector: 'lsz-budget-group',
  templateUrl: './budget-group.component.html',
  styleUrls: ['./budget-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BudgetGroupComponent implements OnInit {
  @Input() public hideClubLogo: boolean;

  public budgetGroups$: BehaviorSubject<Budget[]>;
  public club$: Observable<SoccerClub>;
  public budgetHeaderIcon: unknown;

  constructor(
    private store: Store<AppState>,
    private budgetService: BudgetService,
  ) {
    this.budgetHeaderIcon = faChevronDown;
  }

  public async ngOnInit(): Promise<void> {
    this.club$ = this.store.pipe(select(getClub));
    this.budgetGroups$ = new BehaviorSubject(await firstValueFrom(this.budgetService.get()));
  }

  public panelChange(e: NgbPanelChangeEvent): void {
    this.budgetHeaderIcon = e.panelId === 'panel-Budget' && !e.nextState ? faChevronDown : faChevronUp;
  }
}
